<mwe-collapse titleMessageKey="termsOfUse.listOfContents.title">
  <ng-container>
    <div class="d-flex flex-column gap-3">
      @for (i of items; track i) {
        <mwe-button-link
          [label]="getItemTitleKey(i)"
          [mweScrollToTargetOnClick]="getScrollTarget(i)"
          [dataTest]="'nutzungsbedingungen-link-' + getItemTitleKey(i)"
        />
      }
    </div>
  </ng-container>
</mwe-collapse>
<mwe-collapse titleMessageKey="termsOfUse.conditionsOfUse.title" initialState="expanded">
  <div class="overflow-auto scrollbar-thin p-1" tabindex="0">
    <ng-container>
      @for (i of items; track i) {
        <h6 [attr.id]="getItemId(i)">{{ 'termsOfUse.item' + i + '.title' | translate }}</h6>
        <p [innerHTML]="getItemTextKey(i) | translate | safeHtml"></p>
      }
    </ng-container>
  </div>
</mwe-collapse>
